/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./ingredient-view-graphics";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_IngredientViewGraphicsPage = [];
var RenderType_IngredientViewGraphicsPage = i0.ɵcrt({ encapsulation: 2, styles: styles_IngredientViewGraphicsPage, data: {} });
export { RenderType_IngredientViewGraphicsPage as RenderType_IngredientViewGraphicsPage };
export function View_IngredientViewGraphicsPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "row"]], null, null, null, null, null))], null, null); }
export function View_IngredientViewGraphicsPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-ingredient-view-graphics", [], null, null, null, View_IngredientViewGraphicsPage_0, RenderType_IngredientViewGraphicsPage)), i0.ɵdid(1, 49152, null, 0, i1.IngredientViewGraphicsPage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var IngredientViewGraphicsPageNgFactory = i0.ɵccf("page-ingredient-view-graphics", i1.IngredientViewGraphicsPage, View_IngredientViewGraphicsPage_Host_0, { ingredient: "ingredient" }, {}, []);
export { IngredientViewGraphicsPageNgFactory as IngredientViewGraphicsPageNgFactory };
//# sourceMappingURL=ingredient-view-graphics.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/ingredients/ingredient-view/ingredient-view-graphics/ingredient-view-graphics.ngfactory.js
// module id = null
// module chunks = 